import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import NavbarIconsFinancial from "../generic-nav-bar/NavbarIconsFinancial";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { Link } from "react-router-dom";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import { debugLogPages } from "../../app/helpers/debugHelper";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import { getSectionHeader } from "../../app/helpers/helperValidationViewPreview";

const PreviewFinancial = () => {
  debugLogPages(':: PreviewFinancial');

  const dispatch = useDispatch();
  const { nested, setDetailMode } = useIntegrationNestedPreview();

  const { t } = useTranslation();

  /********Store*******/
  const { financialSelected } = useSelector((state) => state.financial);

  const { listFieldsFinancialView, listFieldsFinancialPreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, setValues } = useFormValidations(
    () => FinancialCallback(),
    financialSelected,
    listFieldsFinancialView
  );

  const FinancialCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Financial', values, setValues);

  useEffect(() => {
    /*JT Load Please */
    dispatch(startLoadingCatalogCiiusAll());

    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());

  }, [])

  const { arrayListPrincipal, arrayListSecondary } = listFieldsFinancialPreview;

  const financialViewRelations = {
    multimedia: "ModuleFile_To_Financial",
    problems: "ModuleProblem_To_Financial"
  };

  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: null, // Mantiene la tabla comentada/desactivada de manera limpia
    relationKeys: financialViewRelations,
    isPreviewMode: true // Filtra mediante show_view_preview
  };

      const principalHeader = getSectionHeader(arrayListPrincipal);
      const secondaryHeader = getSectionHeader(arrayListSecondary);

  const onGoFullVersion = (e) => {
    if (!nested || !setDetailMode) return;
    e.preventDefault();
    setDetailMode('view');
  };

  return (
    <div>
      {!nested && <NavbarIconsFinancial page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="financial"
          record={financialSelected}
        />
      )}

      <div className="d-flex justify-content-center page-title">{t("financial.preview.title")}</div>
      <hr className="line-hr" />
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <div className="text-center fw-bolder">
                <div className="text-center">
                  {nested ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 fw-bolder"
                      onClick={onGoFullVersion}
                    >
                      {t("financial.preview.redirect")}
                    </button>
                  ) : (
                    <Link to="/end-user-search/view-financial">
                      {t("financial.preview.redirect")}
                    </Link>
                  )}
                </div>
              </div>

              <DetailSectionsLayout
                nested={nested}
                isPreviewMode
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PreviewFinancial;
